import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import { removeState } from "../localStorage";
import { resetSession, setIsAuthenticated } from "../reducers/session";

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetSession());
    dispatch(setIsAuthenticated(false));
    removeState();
  }, [dispatch]);

  return <Navigate to="/login" />;
};

export default Logout;
